import * as React from 'react';
import { StyledInformationalPage } from '../../common/static.styles';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

const seo = {
  description: '',
};
const title = 'Sobre';

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='pt-BR' seo={seo}>
    <HeadTitle title={title} />
    <StyledInformationalPage>
      <div className='content'>
        <article>
          <h1>{title}</h1>
          <p>
            A <strong>Warner Bros. Entertainment</strong> é líder global em todas as formas de entretenimento e de seus
            negócios relacionados à todas as mídias atuais e emergentes, assim como suas plataformas. No Grupo Time
            Warner, o Estúdio está à frente de cada aspecto da indústria do entretenimento, desde longa-metragem,
            televisão, e produção de entretenimento em casa, até a distribuição mundial de DVDs e Blu-ray, distribuição
            digital, vídeo games, animação e licença de produtos e suas marcas, além de estação de transmissão. DC
            Entertainment, a empresa por trás dos Super Heróis mundiais mais icônicos, incluindo-se o Batman, o
            Super-homem, a Mulher Maravilha, o Flash e centenas de outros, também faz parte da Warner Bros.
          </p>
          <p>
            Os Estúdios da Warner Bros. começaram quando quatro irmãos, Albert, Sam, Harry e Jack L. Warner,
            incorporaram a incipiente indústria cinematográfica em 4 de abril de 1923. Em 1927, o lançamento do primeiro
            longa-metragem mundial com som sincronizado “The Jazz Singer” deu um formato e um tom de inovação e
            influência que iria se tornar sinônimo do nome Warner Bros.
          </p>
          <p>
            Desde aqueles tempos, os Estúdios da Warner Bros. têm formado um impressionante legado, ao mesmo tempo em
            que está criando uma diversificada empresa de entretenimento com abrangência e profundidade, sem paralelo. A
            consistência da empresa e seu longevo sucesso foram construídos sobre um alicerce de gestão estável ao longo
            de sua história, assim como de relacionamentos criativos de longa data com muitas das maiores estrelas e
            produtores mundiais, além de uma dedicação incansável focado na excelência.
          </p>
          <p>
            Hoje, a biblioteca da Warner Bros., uma das mais prestigiosas e valorosas do mundo, consiste em mais de
            79.000 horas de programação, incluindo quase 7.500 longas-metragens e 4.500 programas de televisão que
            abrangem dezenas de milhares de episódios individuais. O Estúdio também gerencia uma das coleções de mais
            sucesso de marcas e de franquias do mundo.
          </p>
        </article>
      </div>
    </StyledInformationalPage>
  </DefaultLayout>
);
